import React from 'react';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import style from './style.module.less';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const LoadingDisplay = () => {
  return (
    <div className={style['report-loading']}>
      <div className={style['loading-icon-wrap']}>
        <LoadingIndicator className={style['loading-icon']} />
      </div>
      <div>
        <div className={style['error-message']}>
          <FormattedMessage {...messages.loadingMessage} />
        </div>
        <div className={style['error-subtext']}>
          <FormattedMessage {...messages.loadingSubtext} />
        </div>
      </div>
    </div>
  );
};

export default LoadingDisplay;
